import { ConnectProto } from "@racoon/api";
import { useCurrentUser } from "./useCurrentUser";

/**
 * Mirrors the backend's govAuditorProcedures write rule: only
 * USER_ROLE_GOVERNMENT_AUDITOR_EDITOR may mutate gov-dashboard data.
 * UI sugar only — hides or disables write controls; the RBAC interceptor
 * remains the enforcement point, and a call that slips through still
 * surfaces the global error toast.
 */
export function useCanEditGovDash(): boolean {
  const currentUser = useCurrentUser();
  return currentUser?.role === ConnectProto.UserRole.GOVERNMENT_AUDITOR_EDITOR;
}
